export const PRICING = Object.freeze({
  starter: 'https://buy.stripe.com/dRm14n0rV8yVcKy48pfnO0a',
  pro: 'https://buy.stripe.com/bJeaEXeiL9CZ5i6bARfnO08',
  proAnnual: 'https://buy.stripe.com/5kQaEXgqTg1n8uifR7fnO0b',
});

if (typeof window !== 'undefined') {
  window.IndxPricing = PRICING;
}
